import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import _debounce from 'lodash/debounce';
import { mediaHook } from 'customHooks';

import Banner from 'components/Banner/Banner';

import './Container.less';

const Container = ({
  header,
  content,
  className,
  isScrolling,
  mobileScreenSizes: { isMediumMobileScreen, isSmallMobileScreen },
  titleClassName,
  subtitle,
  responsiveTitle,
  containerClassName,
  title
}) => {
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const listInnerRef = useRef();
  const [isContainerSliding, setIsContainerSliding] = useState(
    localStorage.getItem('containerState') === 'false' ||
      localStorage.getItem('containerState') === null
  );

  const handleUserStartScrolling = () => {
    setIsUserScrolling(true);
    if (isScrolling) {
      isScrolling(true);
    }
    if (listInnerRef.current) {
      const { scrollTop } = listInnerRef.current;
      const element = document
        .getElementsByClassName('ant-table-row')[0]
        ?.getBoundingClientRect()?.top;
      if (scrollTop === 0) {
        setIsUserScrolling(false);
      }
      if (element >= 110 && isScrolling) {
        isScrolling(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', function (event) {
      const sideBarStretched = document.getElementsByClassName(
        'br-side-bar__sider-stretched'
      )[0];
      setIsContainerSliding(!!sideBarStretched);
    });
  }, [isContainerSliding]);

  return (
    <div
      className={classnames(
        'br-container',
        'font-family__default',
        {
          'br-container__stretched': isContainerSliding
        },
        { [containerClassName]: !!containerClassName }
      )}
      onScroll={handleUserStartScrolling}
    >
      <div
        className={classnames({
          'br-header-with-shadow': !!isUserScrolling
        })}
      >
        {header}
      </div>
      <div
        onScroll={handleUserStartScrolling}
        ref={listInnerRef}
        className={classnames('br-content br-parent-container', {
          [className]: !!className,
          'br-parent-mobile-container': isSmallMobileScreen
        })}
      >
        {isMediumMobileScreen && title && (
          <div className="br-container__mobile-page-header">
            <span
              className={classnames(
                'br-container__mobile-page-title display-md',
                {
                  [titleClassName]: titleClassName
                }
              )}
            >
              {responsiveTitle ? responsiveTitle : title}
            </span>
            {!!subtitle && (
              <span className="br-container__mobile-page-subtitle body">
                {subtitle}
              </span>
            )}
          </div>
        )}
        {content}
      </div>
    </div>
  );
};

export default mediaHook(Container);
